export default __webpack_public_path__ + "static/media/rocas_sm.732447ae.png";